<template>
  <div v-loading="loading" class="app-container expense-settings">
    <h2>报销设置</h2>
    <p class="muted">维护支付与开票公司，确认审批制度后启用报销。</p>
    <el-alert
      v-if="error"
      :title="error"
      type="error"
      :closable="false"
      show-icon
    />
    <el-tabs
      ><el-tab-pane label="审批制度"
        ><el-form :model="config" label-position="top" class="config-form"
          ><el-form-item label="启用报销提交"
            ><el-switch v-model="config.enabled" /><span class="hint"
              >关闭后可保存草稿，已提交的单据继续办理。</span
            ></el-form-item
          ><el-form-item label="总账会计角色编码" required
            ><el-input v-model="config.ledgerRoleKey" placeholder="zzhj（总账会计）" /></el-form-item
          ><el-form-item label="财务中心负责人角色编码" required
            ><el-input
              v-model="config.financeRoleKey"
              placeholder="例如 cwzj（财务总监）" /></el-form-item
          ><el-form-item label="管理层审批角色编码" required
            ><el-input
              v-model="config.managerRoleKey"
              placeholder="例如 zjl（总经理）" /></el-form-item
          ><el-form-item label="管理层审批规则" required
            ><el-select v-model="config.managerRule"
              ><el-option
                label="每笔报销均需管理层审批"
                value="ALL" /><el-option
                label="预算外或存在例外时审批"
                value="OUTSIDE" /><el-option
                label="达到金额阈值或存在例外时审批"
                value="THRESHOLD" /></el-select></el-form-item
          ><el-form-item
            v-if="config.managerRule === 'THRESHOLD'"
            label="金额阈值（元，达到即触发）"
            required
            ><el-input
              v-model="config.managerThreshold"
              inputmode="decimal" /></el-form-item
          ><el-form-item label="资金会计角色编码" required
            ><el-input v-model="config.cashierRoleKey" placeholder="zjhj（资金会计）" /></el-form-item
          ><el-form-item label="抄送人"
            ><el-select v-model="selectedCc" multiple filterable placeholder="请选择抄送人">
              <el-option v-for="person in ccOptions" :key="person.id" :label="person.name" :value="person.id" />
            </el-select></el-form-item
          ><el-form-item label="已确认制度说明" required
            ><el-input
              v-model="config.configurationNote"
              type="textarea"
              :rows="4"
              maxlength="500"
              show-word-limit /></el-form-item
          ><el-alert
            title="审批顺序：部门经理 → 采购员（如有）→ 总账会计 → 财务中心负责人 → 集团总经理 → 资金会计登记付款。每个审批节点采用或签，有多人时任意一人通过即可进入下一环节。抄送人仅可查看；申请人和报销人不能自审或给自己登记付款。"
            type="info"
            :closable="false"
          /><el-button
            class="save"
            type="primary"
            :loading="saving"
            @click="saveConfig"
            >保存制度</el-button
          ></el-form
        ></el-tab-pane
      >
      <el-tab-pane label="支付与开票公司"
        ><el-button
          type="primary"
          plain
          icon="el-icon-plus"
          @click="editCompany()"
          >添加公司</el-button
        ><el-table :data="companies" style="margin-top: 20px"
          ><el-table-column
            label="公司全称"
            prop="companyName"
            min-width="250"
          /><el-table-column
            label="税号"
            prop="taxNumber"
            min-width="180"
          /><el-table-column label="状态" width="100"
            ><template slot-scope="s"
              ><el-tag :type="s.row.enabled ? 'success' : 'info'">{{
                s.row.enabled ? '启用' : '停用'
              }}</el-tag></template
            ></el-table-column
          ><el-table-column label="操作" width="100"
            ><template slot-scope="s"
              ><el-button type="text" @click="editCompany(s.row)"
                >编辑</el-button
              ></template
            ></el-table-column
          ></el-table
        ></el-tab-pane
      > </el-tabs
    ><el-dialog
      title="公司信息"
      :visible.sync="companyVisible"
      width="min(600px, 94vw)"
      :close-on-click-modal="false"
      ><el-form label-position="top"
        ><el-form-item label="公司全称" required
          ><el-input
            v-model="company.companyName"
            maxlength="150" /></el-form-item
        ><el-form-item label="税号"
          ><el-input v-model="company.taxNumber" maxlength="50" /></el-form-item
        ><el-form-item label="启用"
          ><el-switch v-model="company.enabled" /></el-form-item
      ></el-form>
      <div slot="footer">
        <el-button @click="companyVisible = false">取消</el-button
        ><el-button type="primary" :loading="saving" @click="saveCompany"
          >保存</el-button
        >
      </div></el-dialog
    >
  </div>
</template>
<script>
import {
  expenseOptions,
  expenseCompanies,
  saveExpenseConfig,
  saveExpenseCompany,
} from '@/api/crm/expense'
export default {
  name: 'ExpenseSettings',
  data() {
    return {
      loading: false,
      saving: false,
      error: '',
      config: {},
      selectedCc: [],
      ccOptions: [],
      companies: [],
      company: {},
      companyVisible: false,
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const [o, c] = await Promise.all([expenseOptions(), expenseCompanies()])
        this.config = o.data.config
        this.selectedCc = JSON.parse(this.config.ccUserIds || "[]")
        this.ccOptions = o.data.ccUsers || []
        this.companies = c.data || []
      } catch (e) {
        this.error = e.message || '报销设置加载失败'
      } finally {
        this.loading = false
      }
    },
    async saveConfig() {
      this.saving = true
      try {
        await saveExpenseConfig({ ...this.config, ccUserIds: JSON.stringify(this.selectedCc) })
        this.$message.success('审批制度已保存')
        await this.load()
      } finally {
        this.saving = false
      }
    },
    editCompany(row) {
      this.company = row
        ? { ...row }
        : { companyName: '', taxNumber: '', enabled: true }
      this.companyVisible = true
    },
    async saveCompany() {
      this.saving = true
      try {
        await saveExpenseCompany(this.company)
        this.companyVisible = false
        this.$message.success('公司已保存')
        await this.load()
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
<style scoped>
.expense-settings {
  max-width: 1200px;
  margin: auto;
}
.muted,
.hint {
  color: #77889b;
  line-height: 1.7;
}
.hint {
  margin-left: 12px;
  font-size: 12px;
}
.config-form {
  max-width: 720px;
  padding: 20px 0;
}
.config-form .el-select {
  width: 100%;
}
.save {
  margin-top: 22px;
}
</style>
